import { useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { NFCeImprimir } from "../../../../services/Fiscal.Service";
import { Container, Dropdown, Placeholder } from "react-bootstrap";
import { HeadPage } from "src/componentes";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).href;

export function NFCeImprimirView() {
  const { nfceId } = useParams<{ nfceId: string }>();
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  const [pageWidth, setPageWidth] = useState(0);

  useEffect(() => {
    if (!nfceId) return;
    const loadPdf = async () => {
      const numericId = Number(nfceId);

      if (isNaN(numericId)) {
        console.error("ID inválido");
        return;
      }

      const response = await NFCeImprimir(numericId);

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
    };

    loadPdf();

    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [nfceId]);

  useEffect(() => {
    const updateScale = () => {
      if (!containerRef.current || !pageWidth) return;

      const containerWidth = containerRef.current.offsetWidth;
      setScale(containerWidth / pageWidth);
    };

    updateScale();
    window.addEventListener("resize", updateScale);

    return () => window.removeEventListener("resize", updateScale);
  }, [pageWidth]);

  const baixarDanfe = () => {
    if (!pdfUrl) return;

    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = `DanfeNFCe${nfceId}.pdf`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const compartilhar = async () => {
    if (!pdfUrl) return;

    try {
      const response = await fetch(pdfUrl);
      const pdfBlob = await response.blob();

      const file = new File([pdfBlob], `DanfeNFCe${nfceId}.pdf`, {
        type: "application/pdf",
      });

      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({
          title: "DANFE NFC-e",
          files: [file],
        });
      } else {
        // fallback se não suportar arquivos
        baixarDanfe();
      }
    } catch (err) {
      console.error("Erro ao compartilhar:", err);
    }
  };

  const imprimirDanfe = () => {
    if (!pdfUrl) return;

    const isMobile = /Android|iPhone/i.test(navigator.userAgent);

    if (isMobile) {
      // abre o visualizador nativo
      window.open(pdfUrl, "_blank");
    } else {
      // desktop pode imprimir direto
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.src = pdfUrl;

      document.body.appendChild(iframe);

      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      };
    }
  };

  const onPageLoad = (page: any) => {
    const originalWidth = page.view[2];
    setPageWidth(originalWidth);
  };

  return (
    <Container>
      <HeadPage headText="Imprimir DANFE NFC-e">
        <Dropdown.Item onClick={baixarDanfe}>Baixar</Dropdown.Item>
        <Dropdown.Item onClick={compartilhar}>Compartilhar</Dropdown.Item>
        <Dropdown.Item onClick={imprimirDanfe}>Imprimir</Dropdown.Item>
      </HeadPage>
      {pdfUrl ? (
        <div
          ref={containerRef}
          style={{
            width: "100%",
            height: "100%",
            overflow: "auto",
          }}
        >
          <Document file={pdfUrl}>
            <Page pageNumber={1} scale={scale} onLoadSuccess={onPageLoad} />
          </Document>
        </div>
      ) : (
        <Placeholder animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      )}
    </Container>
  );
}
